export default "__VITE_ASSET__7b8079f9__"